import DepositsPage from './DepositsPage';

export default DepositsPage;
